package com.example.mystybag.login.model

data class MerchantRegistrationAddCompanyAddressUIState(
    val signatories: List<SignatoryItem> = emptyList(),
    /** True after Next pressed with no valid MOL entries. */
    val showMolListError: Boolean = false
)
